import { Link } from 'react-router-dom';
import { CheckCircle2, ArrowRight } from 'lucide-react';
import { useMatter } from '../hooks/useMatter';

export default function ThankYou() {
  const { contact, caseManager } = useMatter();
  const firstName = contact?.given_names ?? '';
  const cmFirst = caseManager?.given_names ?? 'Your case manager';

  return (
    <div className="max-w-2xl mx-auto">
      <div className="card p-10 text-center">
        <div className="w-16 h-16 mx-auto rounded-full bg-green-100 text-green-600 grid place-items-center mb-4">
          <CheckCircle2 size={32} />
        </div>
        <h1 className="text-3xl font-bold mb-2">Thank you{firstName ? `, ${firstName}` : ''}.</h1>
        <p className="text-slate-600 text-lg mb-8">
          Your intake form has been submitted successfully.
        </p>

        <div className="text-left bg-[#EBF7FD] rounded-xl p-5 mb-8">
          <h3 className="font-bold text-[#0B2341] mb-2">What happens next</h3>
          <ul className="space-y-2 text-sm text-slate-700">
            <li>{cmFirst} will review your answers within 1 business day.</li>
            <li>Your sponsor will receive their own form by email shortly.</li>
            <li>We may reach out for clarification on specific items.</li>
            <li>Once your sponsor completes their form, we begin drafting.</li>
          </ul>
        </div>

        <div className="flex flex-wrap gap-3 justify-center">
          <Link to="/dashboard" className="btn-primary">
            Back to dashboard <ArrowRight size={16} />
          </Link>
          <Link to="/documents" className="btn-secondary">
            Upload documents now
          </Link>
        </div>
      </div>
    </div>
  );
}
